import { NgModule } from "@angular/core";
import { CoreModule } from "../../../core/core.module";
import { SharedModule } from "../../../shared/shared.module";
import { CreateLocationsComponent } from "./create-locations/create-locations.component";
import { LocationBulkUploadComponent } from "./location-bulk-upload/location-bulk-upload.component";
import { LocationsComponent } from "./locations.component";
import { ManageLocationComponent } from "./manage-location/manage-location.component";

@NgModule({
  declarations: [CreateLocationsComponent, LocationBulkUploadComponent, LocationsComponent, ManageLocationComponent],
  imports: [CoreModule, SharedModule],
  exports: [CreateLocationsComponent, LocationBulkUploadComponent, LocationsComponent, ManageLocationComponent],
})
export class LocationModule {}
